[
  
  {
    "pageName": "Dashboard",
    "hasChildren": false,
    "route": "/main/landing-page-layout",
    "icon": "landing-page",
    "ref": "landing-page-layout"
  },
  {
    "pageName": "Intern Management",
    "hasChildren": true,
    "route": null,
    "icon": "list",
    "ref": "intern-management",
    "children": [
      {
        "pageName": "Interns",
        "ref": "intern-management/intern-company-list",
        "route": "/main/intern-management/intern-company-list"
      }
    ]
  },
  {
    "pageName": "Company Profile",
    "hasChildren": true,
    "route": null,
    "icon": "list",
    "ref": "company-profile",
    "children": [
      {
        "pageName": "Company Profiles",
        "ref": "company-profile",
        "route": "/main/company-profile"
      },
      {
        "pageName": "Company Users",
        "ref": "company-users",
        "route": "/main/company-users"
      },
      {
        "pageName": "Job Offers",
        "ref": "job-offer",
        "route": "/main/job-offer"
      }
    ]
  }
]
